module.exports = __webpack_public_path__ + "static/media/Moto-PCX (1).d528ab4e.png";